/*if (!customElements.get('mengenrabatt-selector')) {
  class MengenrabattSelector extends HTMLElement {
    connectedCallback() {
      this.options = this.querySelectorAll('.option');
      this.qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');

      this.options.forEach(option => {
        option.addEventListener('click', () => {
          // Active state umschalten
          this.options.forEach(o => o.classList.remove('active'));
          option.classList.add('active');

          // Menge aus data-Attribut setzen
          const qty = parseInt(option.dataset.qty, 10);
          if (this.qtyInput) this.qtyInput.value = qty;
        });
      });
    }
  }

  
  customElements.define('mengenrabatt-selector', MengenrabattSelector);
}*/

if (!customElements.get('mengenrabatt-selector')) {
  class MengenrabattSelector extends HTMLElement {
    connectedCallback() {
      this.options = this.querySelectorAll('.option');
      this.qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');

      // 💡 Wenn auf eine Option geklickt wird
      this.options.forEach(option => {
        option.addEventListener('click', () => {
          // Active state setzen
          this.options.forEach(o => o.classList.remove('active'));
          option.classList.add('active');

          // Menge aus data-Attribut übernehmen
          const qty = parseInt(option.dataset.qty, 10);
          if (this.qtyInput) {
            this.qtyInput.value = qty;
            // "change" Event auslösen, damit andere Skripte (z. B. quantity-selector)
            // darauf reagieren können
            this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // 💡 Wenn Menge per Plus/Minus geändert wird
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => {
          const quantity = parseInt(this.qtyInput.value, 10);
          this.options.forEach(o => o.classList.remove('active'));

          // passende Karte aktivieren
          const match = this.querySelector(`.option[data-qty="${quantity}"]`);
          if (match) match.classList.add('active');
        });
      }
    }
  }

  customElements.define('mengenrabatt-selector', MengenrabattSelector);
}
